import { useMutation, UseMutationOptions, useQueryClient } from 'react-query';

import { useCurrentAssetId } from 'src/Hooks/Shared/useCurrentAssetId';
import { instructionsApi } from 'src/Services/API';
import { CreateInstructionDto, InstructionDto } from 'src/Services/API/generated';
import { trackEvent } from 'src/Services/Matomo';

export const useCreateInstruction = (
  options?: UseMutationOptions<InstructionDto, unknown, CreateInstructionDto>
) => {
  const queryClient = useQueryClient();
  const assetId = useCurrentAssetId();

  return useMutation<InstructionDto, unknown, CreateInstructionDto>(
    ['create-instruction', assetId],
    async instruction => {
      if (!assetId) {
        throw new Error('No asset selected');
      }
      const response = await instructionsApi.instructionsControllerCreate(assetId, instruction);
      return response.data;
    },
    {
      ...options,
      onSuccess: (data, variables, context) => {
        trackEvent('Instruction', 'create', variables.title);
        queryClient.invalidateQueries('fetch-instructions');
        queryClient.invalidateQueries('fetch-documents');
        queryClient.invalidateQueries(['fetch-asset-details', assetId]);
        options?.onSuccess?.(data, variables, context);
      },
    }
  );
};
